
import { Component, Watch, Prop, VModel } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import ProjectMixin from '@/_mixins/project'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import TreeitemDialog from '../dialogs/treeview.vue'

@Component({
    mixins: [ObservationMixin, ProjectMixin],
    components: { DialogTemplate, TreeitemDialog },
})
export default class TreeitemFilter extends Mixins<MixinInterface>(ObservationMixin, ProjectMixin) {
    @VModel() filter!: Array<string>
    @Prop({ required: true }) treeitemType!: string
    @Prop({ required: true }) flatItems!: Array<any>
    @Prop({ default: null, required: false }) project!: string | null
    @Prop({ default: null, required: false }) group!: string | null
    @Prop({ default: false }) hasIsNullOption!: boolean

    dialog = false
    searchTerm = ''
    open = [] as Array<string>
    localFilters = [] as Array<any>

    get isNullLocal() {
        return this.filter.includes('null')
    }

    setisNull(val: boolean) {
        if (val) {
            this.filter = ['null']
        }
    }

    selectFilters(val) {
        this.localFilters = val
        this.filter = this.localFilters.map((val) => val.id)
        this.dialog = false
    }

    removeItem(id: string) {
        this.localFilters = this.localFilters.filter((item) => item.id != id)
        this.selectFilters(this.localFilters)
    }

    // Treeview
    localItems = [] as Array<any>
    localItemsTree = [] as Array<any>

    @Watch('dialog')
    @Watch('filter')
    async setTreeitems() {
        if (!this.flatItems || this.flatItems.length == 0 || this.isNullLocal) return

        let localItems = this.lodash.cloneDeep(this.flatItems)

        this.localFilters = this.lodash
            .cloneDeep(this.filter)
            .map((item) => localItems.find((localItem) => localItem.id == item))

        if (this.project) {
            this.localItems = localItems.filter((item) => item.project.data.id == this.project)

            this.localItemsTree = this.unflattenArray(this.localItems, undefined)
        } else {
            const projectGroupLocalItemsTree = [] as Array<any>
            const projectGroupLocalItems = [] as Array<any>

            this.allProjects.map((project) => {
                const localProject: any = {
                    id: project.id,
                    type: project.type,
                    name: project.attributes.name,
                    children: [],
                }
                let projectLocalItems = localItems.filter(
                    (item) => item.project.data.id == localProject.id
                )

                if (projectLocalItems && projectLocalItems.length > 0) {
                    projectGroupLocalItems.push(...projectLocalItems)

                    localProject.children = this.unflattenArray(projectLocalItems, undefined)
                    projectGroupLocalItemsTree.push(localProject)
                }
            })

            this.localItemsTree = projectGroupLocalItemsTree
            this.localItems = projectGroupLocalItems
        }
        if (!this.dialog) {
            this.localFilters = this.lodash
                .cloneDeep(this.filter)
                .map((id) => this.localItems.find((item) => item.id == id))
        }
    }

    loading = true
    async mounted() {
        if (this.flatItems.length == 0) {
            if (this.treeitemType == 'location') {
                await this.getProjectLocations(this.group, this.project)
            } else if (this.treeitemType == 'cause') {
                await this.getObservationCauses(this.group, this.project)
            } else if (this.treeitemType == 'category') {
                await this.getObservationCategories(this.group, this.project)
            }
        }

        this.loading = false

        this.setTreeitems()
    }
}
